import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    imports: [
        RouterModule
    ],
    selector: 'app-fullpage.layout',
    templateUrl: './fullpage.layout.component.html',
})
export class FullpageLayoutComponent {

}
